<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        v-if="errorMsg"
        variant="warning"
        show
      >
        <div class="alert-body">
          <span>{{ errorMsg }}</span>
        </div>
      </b-alert>
      <b-form
        ref="form"
        class="repeater-form"
        @submit.prevent="repeateAgain"
      >

        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in items"
          :id="index"
          :key="index"
          ref="row"
        >

          <!-- Item Name -->
          <b-col
            md="4"
            class="pt-0 pl-1 pr-1"
          >
            <b-form-group
              :label="$t('DEBTIA_FILE')"
              label-for="item-name"
            >
              <b-form-file
                :id="'file-default-'+index"
                v-model="item.file"
                :class="'file-default-'+index"
                @change="validateFile($event, index), otherFileFieldChanged('file', index)"
              />
            </b-form-group>
          </b-col>

          <!-- Cost -->
          <b-col
            md="4"
            class="pt-0 pl-1 pr-1"
          >
            <b-form-group
              :label="$t('DEBTIA_CATEGORY')"
              label-for="category"
            >
              <v-select
                v-model="item.category_id"
                class="otherfiles_category_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoryOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="otherfiles_category_id"
              />
            </b-form-group>
          </b-col>

          <!-- Quantity -->
          <b-col
            md="3"
            class="pt-0 pl-1 pr-1"
          >
            <b-form-group
              :label="$t('DEBTIA_TITLE')"
              label-for="title"
            >
              <b-form-input
                :id="'title-'+index"
                v-model="item.title"
                type="text"
                :placeholder="$t('DEBTIA_TITLE')"
                @change="otherFileFieldChanged('title', index)"
              />
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            v-if="index > 0"
            md="1"
            class="p-0"
          >
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0 mt-md-2"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
      </b-form>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BRow, BCol, BFormGroup, BButton, BFormFile,
  BFormInput,
  BForm,
  BAlert,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from '@axios'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
// import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BFormGroup,
    BFormFile,
    BForm,
    BAlert,
  },
  directives: {
    Ripple,
  },
  props: {
    caseId: {
      type: [Number, String],
      required: true,
    },
    fileSaved: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loader: false,
      required,
      errorMsg: '',
      categoryOptions: [],
      otherFilesIndex: 1,
      items: [
        {
          recordIndex: 1,
          file: [],
          category_id: 0,
          title: '',
        },
      ],
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.getCategoryOptions()
  },
  methods: {
    hitme() {
      console.log('i am hit')
    },
    getCategoryOptions() {
      const url = '/settings/file-categories-dropdown'
      axios.get(url).then(response => {
        if (response.status === 200) {
          this.categoryOptions = [{ label: 'Select Category', value: 0 }, ...response.data.data]
          // console.log('options are ', options)
        }
      })
    },
    otherFileFieldChanged(input, index) {
      if (input === 'file') {
        document.getElementById(`file-default-${index}`).nextSibling.style['border-color'] = '#d8d6de'
      } else {
        document.getElementById(`title-${index}`).style['border-color'] = '#d8d6de'
      }
    },
    validateFile(event, index) {
      const file = event.target.files[0]
      if (file) {
        const filetype = file.type || ''
        const filename = file.name || ''

        if (!(file
          && ((((filename && filename.includes('.docx'))
            || (filename && filename.includes('.doc'))))
            || (filetype && filetype.includes('pdf'))
            || (filename && filename.toLowerCase().endsWith('.msg'))
            || (filetype && filetype.includes('image/'))))) {
          this.errorMsg = i18n.t('DEBTIA_OTHERFILES_VALIDATION_MESSAGE')
          this.items[index].file = []
        }
      }
    },
    repeateAgain() {
      this.otherFilesIndex += 1
      const obj = {
        recordIndex: this.otherFilesIndex,
        file: [],
        category_id: 0,
        title: '',
      }
      this.items.push(obj)
      console.log('items are ', this.items)
    },
    resetModal() {
      this.otherFilesIndex = 1
      this.errorMsg = ''
      this.items = [
        {
          recordIndex: 1,
          file: [],
          category_id: 0,
          title: '',
        },
      ]
    },
    removeItem(index) {
      let name = ''
      if (this.items[index + 1]) {
        name = this.items[index + 1].file.name
        document.getElementById(`file-default-${index}`).nextSibling.firstChild.innerHTML = name
      }
      this.items.splice(index, 1)
    },
    submitHandler() {
      // evt.preventDefault()
      let empty = false
      this.items.forEach((element, index) => {
        if (element.file.length === 0) {
          empty = true
          document.getElementById(`file-default-${index}`).nextSibling.style['border-color'] = 'red'
        }
        if (!element.title) {
          empty = true
          document.getElementById(`title-${index}`).style['border-color'] = 'red'
        }
      })
      if (!empty) {
        this.loader = true
        this.errorMsg = ''
        const url = '/upload-other-files'
        const form = new FormData()
        const arr = []
        const files = []
        const fileIds = []
        this.items.forEach((element, index) => {
          arr.push(element)
          files.push(element.file)
          fileIds.push(index)
        })
        form.append('debt_case_id', this.caseId)
        form.append('skip', false)
        form.append('data', JSON.stringify(arr))
        fileIds.forEach((index, element) => {
          form.append(`otherfiles_${index + 1}`, files[element])
        })
        axios.post(url, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.fileSaved()
            EventBus.$emit('refreshModules')
            EventBus.$emit('refreshSecondaryProcesses')
          }
        }).catch(error => {
          this.errorMsg = error.response.data.message ? error.response.data.message : error.message
        })
      } else {
        this.errorMsg = 'Fill the highlighted fields.'
      }
    },
  },
}
</script>

  <style lang="scss">
  </style>
